module.exports = __webpack_public_path__ + "static/img/BeCool-Logo-trackpage.6048266.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/BeCool-Logo-trackpage.png
// module id = spbA
// module chunks = 1